import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://tskrgciqlicyruqjrfbh.supabase.co";
const supabaseAnonKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InRza3JnY2lxbGljeXJ1cWpyZmJoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mjk3OTM5NjUsImV4cCI6MjA0NTM2OTk2NX0.ksMC_ZX0cySqzfKRACOZxnTpGf_0QZkYj6fiwzl0Kac";
const supabase = createClient(supabaseUrl, supabaseAnonKey);

export default supabase;
